module.exports = __webpack_public_path__ + "static/media/sound_cold.9d1ace3.wav";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/sound_cold.wav
// module id = N4Bk
// module chunks = 1